import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNServiceCode } from './cnservicecode';
import { CNServiceCodeCustom } from './cnservicecodecustom';
import { CNServiceCodeINAMI } from './cnservicecodeinami';
import { SNItem } from './snitem';

@RegisterItem()
export class CNContactService extends SNItem {

    public codes: CNServiceCode[];

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNContactService';
    }

    get hasServiceCode(): boolean {
        return (this.codes) ? true : false;
    }

    get serviceCodes(): CNServiceCode[] {
        return this.codes;
    }

    addCode(code: CNServiceCode): void {
        if (!this.codes) {
            this.codes = [];
        }
        this.codes.push(code);
    }

    public clone(): any {
        return new CNContactService();
    }

    /**
     * JSON
     */

     public fromJson(json: any, emitLoaded?: boolean): void {
        super.fromJson(json, emitLoaded);
        if (typeof json.codes !== 'undefined' && Array.isArray(json.codes)) {
            // codes
            this.codes = [];
            json.codes.forEach(code => {
                if (code.Key === 'SNItem.CNItem.CNServiceCode.CNServiceCodeINAMI') {
                    const acode = new CNServiceCodeINAMI();
                    acode.fromJson(code);
                    this.codes.push(acode);
                }
                if (code.Key === 'SNItem.CNItem.CNServiceCode.CNServiceCodeCustom') {
                    const acode = new CNServiceCodeCustom();
                    acode.fromJson(code);
                    this.codes.push(acode);
                }
            });
        }
    }

    public toObj(deep = false): any {
        const obj = super.toObj(deep);
        if (this.codes) {
            obj.codes = [];
            this.codes.forEach(code => {
                obj.codes.push(code.toObj(deep));
            });
        }
        return obj;
    }
}
